export default "/images/img_lang.svg?1a3b5d8699208ce78d2c741b51854e8b";